import React from 'react';
import { bibFieldShape } from '@bibliocommons/bc-prop-types';
import FieldValue from 'app/components/bibs/shared/MetadataDisplay/FieldValue';
import { ExpandableList } from '@bibliocommons/expandable';
import { sendAnalyticsEvents } from '@bibliocommons/utils-analytics';
import { bibMetadataEventComposer } from '@bibliocommons/analytics-event-composers';
import AnalyticsConstants from '@bibliocommons/constants-analytics';
import './CatalogContributors.scss';

const MAX_CONTRIBUTORS_DISPLAYED = 3;

const { composeMetadataLinkClickEvent, composeShowMoreEvent } = bibMetadataEventComposer;
const { CUSTOM_DIMENSIONS } = AnalyticsConstants;

function handleClickEvent(contributorNames) {
  sendAnalyticsEvents(
    composeMetadataLinkClickEvent({
      fieldName: contributorNames.get('fieldName'),
      category: 'CONTRIBUTORS',
      gtmContainerName: CUSTOM_DIMENSIONS.CONTAINER_NAMES.BIB_ABOUT
    })
  );
}

function handleShowMoreEvent(expanded) {
  sendAnalyticsEvents(composeShowMoreEvent({ expanded }));
}

export default function CatalogContributors({ contributorNames }) {
  function renderItems() {
    const values = contributorNames.get('fieldValues');
    const renderContributor = contributor => (
      <FieldValue value={contributor} handleClick={() => handleClickEvent(contributorNames)} />
    );

    const getItemKey = item => item.getIn(['primary', 'values', 0]);

    return (
      <ExpandableList
        list={values}
        getItemKey={getItemKey}
        renderItem={renderContributor}
        collapseCount={MAX_CONTRIBUTORS_DISPLAYED}
        expandLinkHref="#show-more-contributors"
        handleToggle={handleShowMoreEvent}
        stacked
        textKey="contributors"
      />
    );
  }

  return <div className="cp-catalog-contributors">{renderItems()}</div>;
}

CatalogContributors.propTypes = {
  contributorNames: bibFieldShape.isRequired
};
